module.exports = __webpack_public_path__ + "img/AuxiliaryAdvisor.f17760d6.svg";